import defaultState from "./state";

const mantenedorTrabajadoresAchsReducer = (state = defaultState, action) => {
  switch (action.type) {
    
    case "SET_LISTA_TRABAJADORES_ACHS": {
      return Object.assign({}, state, {
        listaTrabajadores: action.list,
      });
    }
    case "SET_LISTA_ROLES_ACHS": {
      return Object.assign({}, state, {
        listaRoles: action.list,
      });
    }
    case "LOADING_ROLES_ACHS":{
      return Object.assign({}, state, {
        isLoading: action.isLoading
      })
    }
    case "SET_DATA_ROLES_USER_SELECTED_ACHS": {
      return Object.assign({}, state, {
        dataRolesUserSelected: action.data
      })
    }

    case "RESET_STATE_USERS_ACHS":{
      return Object.assign({}, state, {
        isLoading: false,
        listaTrabajadores: [],
        listaRoles:[],
        dataRolesUserSelected: null
      })
    }
    default:
      return state;
  }
};
export default mantenedorTrabajadoresAchsReducer;